import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { SpecraButton } from '@mono/ui-components/ensigns';
import { SpecraCombobox, SpecraFormField } from '@mono/ui-components/lieutenants';
import { Testids } from '@mono/ui-selectors';
import { useState } from 'react';
import { useLinkableDocuments } from './hooks';
export const HOME_LABEL = {
    LIBRARY: 'Library',
    PROGRAM: 'Program',
    PURSUIT: 'Pursuit',
    PROPOSAL: 'Proposal',
    RFI: 'RFI'
};
// "3 Nov 2026" (d Mon YYYY), stable across runtimes.
const day = (d)=>`${d.getUTCDate()} ${d.toLocaleDateString('en-US', {
        month: 'short',
        timeZone: 'UTC'
    })} ${d.getUTCFullYear()}`;
const describe = (d)=>{
    const home = HOME_LABEL[d.home] ?? d.home;
    const at = d.updatedAt?.toDate();
    return at ? `${home} · ${day(at)}` : home;
};
/** Search the documents the viewer can open, across every Documents hub. */ export function DocumentPickerField({ label, value, onChange, required, disabled }) {
    const [query, setQuery] = useState('');
    const search = useLinkableDocuments(query, true);
    const documents = search.data?.documents ?? [];
    const toOption = (d)=>({
            value: d.artifactId,
            label: d.title,
            textValue: d.title,
            description: describe(d)
        });
    return /*#__PURE__*/ _jsxs(SpecraFormField, {
        label: label,
        error: search.isError ? 'Could not search documents. Try again.' : undefined,
        "data-testid": Testids.registryDocuments.pickerField,
        children: [
            search.isError && /*#__PURE__*/ _jsx(SpecraButton, {
                variant: "ghost",
                disabled: disabled,
                onClick: ()=>void search.refetch(),
                children: "Retry searching documents"
            }),
            /*#__PURE__*/ _jsx(SpecraCombobox, {
                label: label,
                placeholder: "Choose a document",
                searchPlaceholder: "Search documents",
                emptyMessage: "No documents you can open match.",
                // The server filters; cmdk must not filter a second time.
                shouldFilter: false,
                loading: search.isFetching || search.settling,
                disabled: disabled,
                required: required,
                options: documents.map(toOption),
                selectedOption: value ? toOption(value) : undefined,
                value: value?.artifactId,
                onValueChange: (id)=>onChange(documents.find((d)=>d.artifactId === id) ?? undefined),
                onSearchValueChange: setQuery
            })
        ]
    });
}
